<template>
  <div>
    <ValidationObserver ref="formValidator" v-slot="{}">
      <form novalidate @submit.prevent="save">
        <div v-if="!ReadOnly" class="row mt-3">
          <div class="col-12">
            <Error
              is-alert-mode
              message="Los objetivos de los estudiantes deben cumplir con al menos los siguientes componentes: Concepto, Instrumento y Medición"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <b>{{ isEditing ? "Editar" : "Añadir" }} Objetivo:</b>
            <ValidationProvider
              v-slot="{ errors }"
              rules="required"
              name="la descripción"
            >
              <CustomTextarea
                v-model="description"
                required="required"
                :maxlength="500"
                :custom-error-msg.sync="errors[0]"
                :error="errors[0]"
                :disabled="ReadOnly"
              />
            </ValidationProvider>
          </div>
        </div>

        <div class="d-flex px-0 mt-2">
          <div
            class="col-9 pl-0 d-flex justify-content-start align-items-start"
          >
            <div class="col-md-3 pl-0 col-sm-12">
              <ValidationProvider
                v-slot="{ errors }"
                rules="required"
                name="la adecuación"
              >
                <CustomDropDown
                  v-model="selectedCodeObj"
                  :options="adequacyOptions"
                  fieldkey="id"
                  fieldname="spaShortDescription"
                  placeholder="Seleccione"
                  label="Medición:"
                  class="block-spacing"
                  :error="errors[0]"
                  :custom-error-msg="resource('R03200129')"
                  :disabled="ReadOnly"
                />
              </ValidationProvider>
            </div>
            <div
              v-if="selectedCode > 0"
              :key="variableKey"
              class="col-3 pt-4"
            >
              <ValidationProvider
                v-slot="{ errors }"
                rules="required"
                :name="getMeasure1Name"
              >
                <CustomInput
                  v-model="currentObj.measure1Amt"
                  type="number"
                  :required="selectedCode > 0 ? 'required' : ''"
                  :custom-error-msg.sync="errors[0]"
                  :error="errors[0]"
                  :disabled="ReadOnly"
                  @input="resetAlert()"
                />
              </ValidationProvider>
            </div>

            <div
              v-show="selectedCode == attempstCode"
              class="col-1 d-flex align-items-end pt-4"
            >
              <span
                v-show="selectedCode == attempstCode"
                class="text-center mx-4 my-2"
              >
                de
              </span>
            </div>
            <div v-if="selectedCode == attempstCode" class="col-3 pt-4">
              <ValidationProvider
                v-slot="{ errors }"
                rules="required"
                name="los intentos de adecuación"
              >
                <CustomInput
                  v-model="currentObj.measure2Amt"
                  type="number"
                  required
                  :custom-error-msg.sync="errors[0]"
                  :error="errors[0]"
                  :disabled="ReadOnly"
                  @input="resetAlert()"
                />
              </ValidationProvider>
            </div>
          </div>
          <div
            v-if="!ReadOnly"
            class="col-3 d-flex justify-content-end align-items-start pt-4"
          >
            <ActionButton
              v-if="isFormFilled"
              i="fas fa-times-circle"
              variant="outline-danger m-2"
              @click="clearForm()"
            >
              Cancelar
            </ActionButton>

            <ActionButton
              i="fas fa-save"
              variant="success m-2"
              :type="'submmit'"
            >
              Guardar
            </ActionButton>
          </div>
        </div>
        <br />
        <Error
          v-if="customErrorMsg && customErrorMsg != ''"
          variant="no-border"
          :message="customErrorMsg"
        />
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver, extend } from "vee-validate";
import * as rules from "vee-validate/dist/rules";
import { messages } from "@/components/pei/programservice/goals/locales/es.json";
import alert from "@/mixin/alert.mixin";
import peiGoalMeasures from "@/utils/constants/pei/peiGoalMeasures";
import CustomTextarea from "@/components/common/CustomTextArea";
import ActionButton from "@/components/common/ActionButton";
import CustomInput from "@/components/common/CustomInput";
import CustomDropDown from "@/components/common/CustomDropDown";
import Error from "@/components/common/Error";

import { modulesName } from "@/modules";
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers(
  modulesName.programServiceModuleName
);

export default {
  mixins: [alert],
  name: "ObjectiveForm",
  components: {
    CustomTextarea,
    ActionButton,
    ValidationProvider,
    ValidationObserver,
    CustomInput,
    CustomDropDown,
    Error
  },
  data() {
    return {
      description: "",
      customErrorMsg: "",
      currentObj: "",
      selectedCode: 0,
      isLoaded: false,
      selectedCodeObj: null,
      variableKey: Math.random(),
      attempstCode: peiGoalMeasures.attempts,
      percentualCode: peiGoalMeasures.percentual
    };
  },
  props: {
    goal: {
      type: Object
    },
    objective: {
      type: Object
    },
    isEditing: {
      type: Boolean,
      default: false
    },
    ReadOnly: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    resetAlert() {
      this.customErrorMsg = "";
    },
    clearForm() {
      this.description = "";
      this.selectedCode = 0;
      this.selectedCodeObj = null;
      this.$emit("cancel-objective");
    },
    setSelectedPeiCode() {
      this.customErrorMsg = "";
      this.selectedCode = !this.selectedCodeObj ? 0 : this.selectedCodeObj.id;
      this.variableKey = Math.random();
      if (this.currentObj && !this.isLoaded) {
        this.currentObj.measure1Amt = null;
        this.currentObj.measure2Amt = null;
        this.isLoaded = false;
      }
      if (this.selectedCode == peiGoalMeasures.percentual) {
        this.currentObj.measure2Amt = null;
      }
    },
    validateCustomErrors() {
      switch (this.selectedCode) {
        case this.attempstCode: {
          if (
            parseInt(this.currentObj.measure1Amt) >
            parseInt(this.currentObj.measure2Amt)
          ) {
            this.customErrorMsg = this.resource("R900006");
            return false;
          } else if (
            parseInt(this.currentObj.measure1Amt) <= 0 ||
            parseInt(this.currentObj.measure2Amt) <= 0
          ) {
            this.customErrorMsg = this.resource("R900009");
            return false;
          }
          break;
        }
        case this.percentualCode: {
          if (
            parseInt(this.currentObj.measure1Amt) < 0 ||
            parseInt(this.currentObj.measure1Amt) > 100
          ) {
            this.currentObj.measure2Amt = 0;
            this.customErrorMsg = this.resource("R900008");
            return false;
          }

          break;
        }
      }

      return true;
    },
    async save() {
      this.customErrorMsg = "";
      const isFormValid = await this.$refs.formValidator.validate();
      const customValidation = this.validateCustomErrors();
      if (!isFormValid || !customValidation) return isFormValid;

      this.currentObj.peiProgramServiceObjectivelId = this.currentObj
        .peiProgramServiceObjectivelId
        ? parseInt(this.currentObj.peiProgramServiceObjectivelId)
        : 0;
      this.currentObj.peiObjectiveMeasureCode = this.selectedCode;
      this.currentObj.objectiveDescription = this.description;
      this.currentObj.peiProgramServiceGoalId = this.goal.peiProgramServiceGoalId;
      this.currentObj.measure2Amt =
        !this.currentObj.measure2Amt || isNaN(this.currentObj.measure2Amt)
          ? 0
          : parseInt(this.currentObj.measure2Amt);
      this.currentObj.measure1Amt =
        !this.currentObj.measure1Amt || isNaN(this.currentObj.measure1Amt)
          ? 0
          : parseInt(this.currentObj.measure1Amt);
      this.currentObj.measure2Amt = peiGoalMeasures.percentualCode
        ? 0
        : this.currentObj.measure2Amt;

      this.$emit("add-objetive", this.currentObj);
      return isFormValid;
    },
    async resetForm() {
      Object.keys(rules).forEach(rule => {
        const ruleObj = {
          ...rules[rule], // copies rule configuration
          message: messages[rule]
            ? messages[rule].replace("{_object_}", "")
            : ""
        };
        extend(rule, ruleObj);
      });

      this.currentObj = this.objective
        ? {
            peiProgramServiceObjectivelId: this.objective
              .peiProgramServiceObjectivelId,
            peiObjectiveMeasureCode: this.objective.peiObjectiveMeasureCode,
            peiProgramServiceGoalId: this.objective.peiProgramServiceGoalId,
            measure1Amt: this.objective.measure1Amt,
            measure2Amt: this.objective.measure2Amt,
            objectiveDescription: this.objective.objectiveDescription
          }
        : {};

      if (
        this.currentObj.peiProgramServiceObjectivelId &&
        this.currentObj.peiProgramServiceObjectivelId > 0
      )
        this.isLoaded = true;

      this.description =
        this.objective && this.objective.objectiveDescription
          ? this.objective.objectiveDescription
          : "";

      this.selectedCode =
        this.objective && this.objective.peiObjectiveMeasureCode
          ? this.objective.peiObjectiveMeasureCode
          : 0;

      this.selectedCodeObj =
        this.adequacyOptions && this.selectedCode > 0
          ? this.adequacyOptions.find(x => x.id == this.selectedCode)
          : null;
    }
  },
  computed: {
    ...mapGetters(["resource", "adequacyOptions"]),
    isFormFilled() {
      return this.description || (this.selectedCode && this.selectedCode > 0);
    },
    getMeasure1Name() {
      return this.selectedCode == this.percentualCode
        ? "el porciento de la adecuación"
        : " los intentos de adecuación";
    },
    hasCreationPendingChange() {
      if (this.isEditing) return false;

      return !!this.description ||
        !!this.selectedCodeObj?.id ||
        !!this.currentObj?.measure1Amt ||
        !!this.currentObj?.measure2Amt;
    },
  },
  watch: {
    selectedCodeObj() {
      this.setSelectedPeiCode();
    },
    hasCreationPendingChange(newValue) {
      if (this.isEditing) return;

      this.$emit('pending-change', newValue);
    },
  },
  async created() {
    this.resetForm();
  }
};
</script>
